import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AnqServicesService } from './api/anqServices.service';
import { ApiCredentialsService } from './api/apiCredentials.service';
import { BatchSmsJobService } from './api/batchSmsJob.service';
import { BillingTransactionLogsService } from './api/billingTransactionLogs.service';
import { DashBoardService } from './api/dashBoard.service';
import { FeedbackService } from './api/feedback.service';
import { LocalDeleteService } from './api/localDelete.service';
import { MTMOFilterService } from './api/mTMOFilter.service';
import { MessageService } from './api/message.service';
import { MessageDeliveryStatusService } from './api/messageDeliveryStatus.service';
import { PlatformService } from './api/platform.service';
import { PlatformServiceSubscriptionProcessService } from './api/platformServiceSubscriptionProcess.service';
import { SenderIdMapService } from './api/senderIdMap.service';
import { SenderIdRequestService } from './api/senderIdRequest.service';
import { ServiceService } from './api/service.service';
import { ServiceBillingTransactionService } from './api/serviceBillingTransaction.service';
import { ServiceSubscriptionService } from './api/serviceSubscription.service';
import { SmppActionService } from './api/smppAction.service';
import { SmppClientService } from './api/smppClient.service';
import { SmppCredentialsService } from './api/smppCredentials.service';
import { SmppToolsService } from './api/smppTools.service';
import { SmsBillingSettingsService } from './api/smsBillingSettings.service';
import { SmsClientService } from './api/smsClient.service';
import { SmsMerchantService } from './api/smsMerchant.service';
import { SmsPriceSetupService } from './api/smsPriceSetup.service';
import { SmsProcessService } from './api/smsProcess.service';
import { SmsRouteMapService } from './api/smsRouteMap.service';
import { SmsRoutesService } from './api/smsRoutes.service';
import { SmtpSettingsService } from './api/smtpSettings.service';
import { SubscriptionsService } from './api/subscriptions.service';
import { ThresholdService } from './api/threshold.service';
import { TransactionLogService } from './api/transactionLog.service';
import { UserFeedbackService } from './api/userFeedback.service';
import { ValuesService } from './api/values.service';
import { VatService } from './api/vat.service';
import { WalletService } from './api/wallet.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AnqServicesService,
    ApiCredentialsService,
    BatchSmsJobService,
    BillingTransactionLogsService,
    DashBoardService,
    FeedbackService,
    LocalDeleteService,
    MTMOFilterService,
    MessageService,
    MessageDeliveryStatusService,
    PlatformService,
    PlatformServiceSubscriptionProcessService,
    SenderIdMapService,
    SenderIdRequestService,
    ServiceService,
    ServiceBillingTransactionService,
    ServiceSubscriptionService,
    SmppActionService,
    SmppClientService,
    SmppCredentialsService,
    SmppToolsService,
    SmsBillingSettingsService,
    SmsClientService,
    SmsMerchantService,
    SmsPriceSetupService,
    SmsProcessService,
    SmsRouteMapService,
    SmsRoutesService,
    SmtpSettingsService,
    SubscriptionsService,
    ThresholdService,
    TransactionLogService,
    UserFeedbackService,
    ValuesService,
    VatService,
    WalletService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
